import I18n from "common/i18n";
import { BuilderCommandId, CommandLimits } from "features/builder/types";
import { COMMAND_TO_BLOCK } from "../blockly/Toolbox";

// フライアウトの各ブロックの実高さと配色（algorithm コースの BlockLimits と同じ値）。
// チップをブロックと同じ縦リズム（高さ + 間隔 24px）で並べて位置を揃える。
const blockStyleMapping = (
  blockType: string,
): { height: number; color: string; borderColor: string } => {
  switch (blockType) {
    case "character_motion_move":
    case "character_motion_jump":
    case "character_motion_turn_left":
    case "character_motion_turn_right":
      return { height: 56, color: "#4C97FF", borderColor: "#3971bf" };
    case "controls_repeat_internal":
      return { height: 125, color: "#FFAB19", borderColor: "#bf8013" };
    case "controls_whileUntil_colour_internal":
    case "controls_if_colour_internal":
      return { height: 112, color: "#FFAB19", borderColor: "#bf8013" };
    default:
      return { height: 56, color: "#4C97FF", borderColor: "#3971bf" };
  }
};

// フライアウトパネル内・ブロック列の左隣に「のこり N」を表示する縦列
// （algorithm コースの BlockLimits と同じ flow 配置・縦リズム）。
// 個数制限のないブロックには残数の代わりに「むせいげん」を表示する。
export const PreviewBlockLimits = ({
  enabledCommands,
  limits,
  remaining,
  offset,
  width,
  height,
  scale,
}: {
  enabledCommands: BuilderCommandId[];
  limits: CommandLimits;
  remaining: { [type: string]: number };
  offset: number;
  width: number;
  height: number;
  scale: number;
}) => {
  return (
    <div
      className="flex-col-view"
      style={{
        top: offset * scale,
        left: 6 * scale,
        width: width * scale,
        height: height - offset * scale - 75 * scale,
      }}
    >
      <div className="flex-col-center !justify-start w-full h-full overflow-x-clip overflow-y-hidden">
        {enabledCommands.map((cmd, index) => {
          const block = COMMAND_TO_BLOCK[cmd];
          if (!block) return null;
          const style = blockStyleMapping(block.type);
          const limit = limits[cmd];
          return (
            <div
              key={cmd}
              className="flex-col-center"
              style={{
                width: 96 * scale,
                height: style.height * scale,
                marginTop: index === 0 ? 8 * scale : 0,
                marginBottom: 24 * scale,
              }}
            >
              <div
                className="flex-col-center w-24 rounded-md border-solid border"
                style={{
                  transform: `scale(${scale})`,
                  height: style.height,
                  backgroundColor: style.color,
                  borderColor: style.borderColor,
                }}
              >
                <p className="type-text type-sm text-white whitespace-nowrap leading-tight">
                  {I18n.t("MSG_BUILDER_PREVIEW_REMAINING")}
                </p>
                {limit != null ? (
                  <p className="type-text type-body text-white">{remaining[block.type] ?? limit}</p>
                ) : (
                  <p className="type-text type-sm text-white whitespace-nowrap leading-tight">
                    {I18n.t("MSG_BUILDER_PREVIEW_UNLIMITED")}
                  </p>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
